import React from 'react';

import { RouterProvider } from 'react-router-dom';
import 'App.css';

import { NavBar } from 'components/NavBar';

import 'css/bootstrap.css';
import { router } from 'routes';
import { ACCELERATED_LOADING, BROWSER_SESSION_BASED_LOADING_HOME, LOADING_SPEED_FACTOR } from 'config';

const MESSAGE_POOL: string[] = [
  'loading good vibes ...',
  'warming up the hamsters ...',
  'blowing dust off the CPU ...',
  'asking the computer nicely ...',
  'mounting the vibes ...',
  'unfolding pixels ...',
  'reticulating splines ...',
  'downloading more RAM ...',
  'poking the router ...',
  'convincing the internet to work ...',
  'bribing the packets ...',
  'remembering who you are ...',
  'putting on the finishing touches ...',
  'straightening the pixels ...',
  'brewing one more coffee ...',
  'tokenizing the vibes ...',
  'lowering IR to something we can afford ...',
  'unrolling loops ...',
  'constant-folding ...',
  'eliminating dead code ...',
  'linking against libgoodtime.so ...',
  'emitting suspiciously fast assembly ...',
  'spilling registers ...',
  'garbage collecting ...'
];

const PHASE_COUNT = 3;

const pickPhaseMessages = (): string[] => {
  const shuffled = [...MESSAGE_POOL].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, PHASE_COUNT);
};

declare global {
  interface Window {
    _386: any;
  }
}
interface HomeState {
  loadProgress: number;
  loadFactor: number;
  phaseMessages: string[];
}

export default class App extends React.Component<{}, HomeState> {
  constructor(props: {}) {
    super(props);
    let loadProgress = 0;
    let loadFactor = LOADING_SPEED_FACTOR;
    const progress = sessionStorage.getItem('homeLoadProgress');
    if (BROWSER_SESSION_BASED_LOADING_HOME) {
      loadProgress = progress == null ? 0 : parseInt(progress, 10);
      loadFactor = LOADING_SPEED_FACTOR;
    }
    if (progress != null && ACCELERATED_LOADING) {
      loadFactor = LOADING_SPEED_FACTOR / 4;
    }
    this.state = {
      loadProgress,
      loadFactor,
      phaseMessages: pickPhaseMessages()
    };
  }

  init386(): void {
    window._386?.magicCursor();
    window._386?.scrollLock();
  }

  componentDidMount(): void {
    window.addEventListener('load', () => {
      this.init386();
    });
    this.init386();

    if (this.state.loadProgress !== 100) {
      for (let i = 1; i <= 100; i++) {
        setTimeout(() => {
          this.setState({ loadProgress: i });
          sessionStorage.setItem('homeLoadProgress', i.toString());
        }, i * this.state.loadFactor);
      }
    }
  }

  render(): React.ReactNode {
    const { loadProgress, loadFactor, phaseMessages } = this.state;
    const phaseMessage =
      loadProgress >= 100
        ? 'vibes loaded. welcome.'
        : phaseMessages[Math.min(PHASE_COUNT - 1, Math.floor((loadProgress / 100) * PHASE_COUNT))];
    const timestamp = ((loadProgress * loadFactor) / 1000).toFixed(6).padStart(12, ' ');
    const ready = loadProgress === 100;
    return (
      <div>
        <div hidden={loadProgress === 100} style={{ margin: '10% 2%' }}>
          <div style={{ fontFamily: 'monospace', color: ready ? 'var(--success)' : 'inherit', marginBottom: '0.5rem' }}>
            <span style={{ color: ready ? 'var(--success)' : 'var(--primary)' }}>[{timestamp}]</span> {phaseMessage}
          </div>
          <div className="progress">
            <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${loadProgress}%` }}></div>
          </div>
        </div>

        <div
          className="App bootstra-enable-cursor container col-md-8 col-sm-11 text-left"
          hidden={this.state.loadProgress !== 100}
        >
          <NavBar />
          <div>
            <RouterProvider router={router} />
          </div>
          <footer>
            <p className="text-center">
              <span className="strikethrough">©</span>
              <a href="https://unlicense.org/" style={{ marginLeft: 10, marginRight: 10 }}>
                UNLICENSE
              </a>
              <span>1990 - {new Date().getFullYear()}</span>
              <span> v.{process.env.REACT_APP_VERSION}</span>
            </p>
          </footer>
        </div>
      </div>
    );
  }
}
